import FormBuilder from "../../../../shared/components/FormBuilder";
import { HeaderComponent } from "../../../../shared/components/HeaderComponent";
import { Loader } from "../../../../shared/components/Loader";
import { Box } from "@mui/material"; 
import ComponentTable from "../../../Components/Table/Index";
import useMovimentacaoEstoquePesquisar from "../../../../hooks/useMovimentacaoEstoquePesquisar";

export default function MovimentacaoEstoquePesquisar() {
    const {
        loading,
        initialValues,
        tableColumns,
        tableRows,
        fields,
        handleSubmit,
    } = useMovimentacaoEstoquePesquisar();

    return (
        <Loader loading={loading}>
            <Box>
                <HeaderComponent text={'Movimentação de Estoque'} />
                <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} />
                <ComponentTable columns={tableColumns} rows={tableRows} />
            </Box>
        </Loader>
    );
}